export const normalizeStatus = (status) => String(status || "").toLowerCase();

export const ADMIN_STAFF_APPROVER_EMAIL = "admin@greenspaceindustries.com.au";

export const normalizeEmail = (email) => String(email || "").trim().toLowerCase();

export const isAccountantApprover = (userInfo) =>
  normalizeEmail(userInfo?.email) === ADMIN_STAFF_APPROVER_EMAIL;

export const isAdminStaffSubmission = (item) =>
  String(item?.submitterRole || item?.employeeRole || item?.staffRole || "")
    .toLowerCase() === "admin";

export const isTimesheetSubmission = (item) =>
  normalizeStatus(item?.status) === "submitted";

export const isLeaveSubmission = (item) =>
  ["pending", "submitted"].includes(normalizeStatus(item?.status));

export const isLeaveDecision = (item) =>
  ["approved", "rejected"].includes(normalizeStatus(item?.status));

export const isUnseenLeaveDecision = (item) =>
  isLeaveDecision(item) && !item?.driverDecisionSeenAt;

export const formatNotificationCount = (count) => {
  const value = Number(count || 0);
  if (value <= 0) return "";
  if (value > 99) return "99+";
  return String(value);
};
